import { render, staticRenderFns } from "./Organizations.vue?vue&type=template&id=93a0b1ea&scoped=true"
import script from "./Organizations.vue?vue&type=script&lang=js"
export * from "./Organizations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a0b1ea",
  null
  
)

export default component.exports